// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BadgeImagePlacementValues, BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useRef } from "react";

/* Toolkit Custom Code - Start */
import includes from "lodash/includes";
/* Toolkit Custom Code - End */

interface Props {
    productContext: ProductContextModel;
    showTextBadge?: boolean;
    showImageBadge?: boolean;
    styles?: { badgeTextWrapper?: InjectableCss; badgeImageWrapper?: InjectableCss };
}

/**
 * Manages the positioning for badges that overlay a product image.
 * @param props
 */
const useOverlayBadge = ({ productContext, showTextBadge, showImageBadge, styles }: Props) => {
    let showOverlayBadge = false;
    let overlayBadge = null;
    let overlayBadgeWrapperStyles = null;

    if (productContext.product.badges && productContext.product.badges.length > 0) {
        let visibleBadges = productContext.product.badges.filter(badge => badge.displayOnProductImages);

        if (!showImageBadge && visibleBadges.length > 0) {
            visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Image);
        }

        if (!showTextBadge && visibleBadges.length > 0) {
            visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Text);
        }

        if (visibleBadges.length > 0) {
            overlayBadge = visibleBadges[0];
            /* Toolkit Custom Code - Start */
            const { badgeType } = overlayBadge;
            const isImageBadgeType = Boolean(badgeType === BadgeTypeValues.Image);
            const isTextBadgeType = Boolean(badgeType === BadgeTypeValues.Text);
            /* Toolkit Custom Code - End */
            showOverlayBadge = true;
            overlayBadgeWrapperStyles = isImageBadgeType ? styles?.badgeImageWrapper : styles?.badgeTextWrapper; // Toolkit Custom Code
            // Toolkit Removed - width
            let positioning = "";

            if (overlayBadge.largeImagePlacement) {
                if (isImageBadgeType /* Toolkit Custom Code */) {
                    switch (overlayBadge.largeImagePlacement) {
                        case BadgeImagePlacementValues.TopLeft:
                            positioning = "left: 2%; top: 2%;";
                            break;
                        case BadgeImagePlacementValues.TopCenter:
                            positioning = `left: 50%; transform: translateX(-50%); top: 2%;`; // Toolkit Custom Code
                            break;
                        case BadgeImagePlacementValues.TopRight:
                            positioning = "right: 2%; top: 2%;";
                            break;
                        case BadgeImagePlacementValues.BottomLeft:
                            positioning = "left: 2%; bottom: 2%;";
                            break;
                        case BadgeImagePlacementValues.BottomCenter:
                            positioning = `left: 50%; transform: translateX(-50%); bottom: 2%;`; // Toolkit Custom Code
                            break;
                        case BadgeImagePlacementValues.BottomRight:
                            positioning = "right: 2%; bottom: 2%;";
                            break;
                        default:
                            positioning = "left: 2%; top: 2%;";
                    }
                }
                /* Toolkit Custom Code - Start */
                if (isTextBadgeType) {
                    switch (overlayBadge.largeImagePlacement) {
                        case BadgeImagePlacementValues.TopLeft:
                            positioning = "left: 2%; top: 2%; margin-right: 2%;";
                            break;
                        case BadgeImagePlacementValues.TopCenter:
                            positioning = `left: 0; right: 0; margin: 0 2%; display: flex; justify-content: center; top: 2%;`;
                            break;
                        case BadgeImagePlacementValues.TopRight:
                            positioning = "right: 2%; top: 2%; margin-left: 2%;";
                            break;
                        case BadgeImagePlacementValues.BottomLeft:
                            positioning = "left: 0%; bottom: 2%;"; // Store Custom Code
                            break;
                        case BadgeImagePlacementValues.BottomCenter:
                            positioning = `left: 0; right: 0; margin: 0 2%; display: flex; justify-content: center; margin: 0 auto; bottom: 2%;`;
                            break;
                        case BadgeImagePlacementValues.BottomRight:
                            positioning = "right: 0%; bottom: 2%;"; // Store Custom Code
                            break;
                        default:
                            positioning = "left: 2%; top: 2%; margin-right: 2%;";
                    }
                }
                /* Toolkit Custom Code - End */
            }
            /* Toolkit Custom Code - Start */
            if (overlayBadgeWrapperStyles?.css && !includes(overlayBadgeWrapperStyles?.css, positioning)) {
                overlayBadgeWrapperStyles.css = overlayBadgeWrapperStyles.css.concat(positioning);
            }
            /* Toolkit Custom Code - End */
        }
    }

    const badgeAreaWrapperRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
    const overlayBadgeWrapperClickHandler = () => {
        if (badgeAreaWrapperRef.current) {
            (badgeAreaWrapperRef.current.firstChild as HTMLLinkElement).click();
        }
    };

    return {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    };
};

export default useOverlayBadge;
